import {
    allFormatRegex,
    getFileExtension,
    getFileManagerParent,
    getFileNameWithoutFormat,
    getPlanStatus,
    getWebEnvConfig,
    isFolder,
    isTouchScreen,
    previewValidFormats,
    UnitConvertStandard
} from "../../../../../scripts/helpers";
import { ResourceCardProps } from "./resourceCard.interface";
import { DeviceEnum } from "../../../../../redux/slices/environmentSlice";
import { useLongPress } from "use-long-press";
import {
    collaboraExtensionsChecker,
    collaboraOtherExtensionsChecker,
    handleClearAllSelectedResources,
    handleClearDefaultSelectedItem,
    handleOpenCollabora,
    handleSelectResources,
    handleSetCollaboraModalStatus,
    handleSetDownloadConfirmationModalStatus,
    handleSetDownloadModalStatus,
    handleSetIsSingleSelect,
    handleSetLinkUploadModalStatus,
    handleSetPreviewModalStatus,
    handleSetRenameModalStatus,
    handleSetResources,
    handleSetShareModalStatus,
    handleUpdateResources
} from "../../fileManager.actions";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { FileManagerView } from "../../../../../redux/slices/fileManagerSlice";
import {
    addToFavoriteResources,
    cutResources,
    deleteFromFavoriteResources,
    downloadResource,
    isDefaultSelected,
    isResourceSelected,
    setContextMenu,
    syncFileManager
} from "../../fileManager.function";
import { FileManagerModeEnum, LinkUploadStatus, ResourceType } from "../../../../../interfaces/general";
import moment from "moment-jalaali";
import tick from "../../../../../assets/images/icons/Tick.svg";
import more from "../../../../../assets/images/fileManager/VerticalMore.svg";
import folderIcon from "../../../../../assets/images/fileManager/Folder.svg";
import star from "../../../../../assets/images/fileManager/Star.svg";
import { ReactComponent as SharedIcon } from "../../../../../assets/images/fileManager/Shared.svg";
import { ReactComponent as LinkUploadSign } from "../../../../../assets/images/fileManager/linkUplaodSign.svg";
import { ReactComponent as RetryUploadLink } from "../../../../../assets/images/fileManager/retryUploadLink.svg";
import { ReactComponent as LinkUploadLoader } from "../../../../../assets/images/fileManager/UploadLinkloader.svg";
import uploadLinkFailed from "../../../../../assets/images/fileManager/uploadFailed.svg";
import RedClose from "../../../../../assets/images/fileManager/redClose.svg";
import PATH from "../../../../../urls/path";
import { contextMenuState } from "../contextMenu/contextMenu.interface";
// @ts-ignore
import { getFilesFromDataTransferItems } from "datatransfer-files-promise";
import NameDisplay from "../../../displayFaEn/showCorrectName/showCorrectName.index";
import { advancedResponseValidator, del, get, post, responseValidator } from "../../../../../scripts/api";
import API from "../../../../../urls/api";
import ConfirmationModal from "../../../confirmationModal/confirmationModal.index";
import { setResourceIcon } from "../../../../../scripts/resourceHelper";
import { toast } from "mobin-toast";
import { ReactComponent as Rename } from "../../../../../assets/images/fileManager/context/Rename.svg";
import { ReactComponent as Share } from "../../../../../assets/images/fileManager/context/Share.svg";
import { ReactComponent as Download } from "../../../../../assets/images/fileManager/context/Download.svg";
import { ReactComponent as Star } from "../../../../../assets/images/fileManager/context/Star.svg";
import { ReactComponent as StarSlash } from "../../../../../assets/images/fileManager/context/StarSlash.svg";
import { ReactComponent as Folder } from "../../../../../assets/images/fileManager/context/folder-2.svg";
import { toastMessages } from "../../../../../scripts/toastMessages";
import { shallowEqual } from "react-redux";
import { useAppSelector } from "../../../../../redux/hooks";
import AntivirusStatus from "../../../AntivirusStatus/AntivirusStatus";
import ReactTooltip from "react-tooltip";
import Dialog from "../../../dialog/dialog.index";
import { ENVIRONMENT } from "../../../../../environment";
import { LockExcelDialog } from "../../../LockExcelDialog";

export default function ResourceCard({
    resource,
    onDropFiles,
    index,
    mode,
    onFileDragOver,
    onFileDragLeave,
    parentDrag,
    detail,
    view
}: ResourceCardProps): JSX.Element {
    const { device } = useAppSelector(({ environment: { device } }) => ({ device }), shallowEqual);
    const { filteredResources, selectedResources, giftPurchase, resources, defaultSelectedResourse, isSingleSelect, activePurchases } =
        useAppSelector(
            ({
                fileManager: {
                    filteredResources,
                    giftPurchase,
                    selectedResources,
                    resources,
                    defaultSelectedResourse,
                    isSingleSelect,
                    activePurchases
                }
            }) => ({
                filteredResources,
                selectedResources,
                resources,
                defaultSelectedResourse,
                isSingleSelect,
                activePurchases,
                giftPurchase
            }),
            shallowEqual
        );

    const navigate = useNavigate();
    const [dragStatus, setDragStatus] = useState<boolean>(false);
    const [errorDialog, setErrorDialog] = useState<boolean>(false);
    const [removeFailedUploadLink, setRemoveFailedUploadLink] = useState<boolean>(false);
    const { user } = useAppSelector(({ auth: { user } }) => ({ user }), shallowEqual);
    const [_intervalId, setIntervalId] = useState<any[]>([]);
    const myRef = useRef<any>(null);
    const location = useLocation();

    useEffect(() => {
        ReactTooltip.rebuild();
    });

    const bindLongPress = useLongPress(() => {
        if (selectedResources.length === 0 && device !== DeviceEnum.desktop && mode !== FileManagerModeEnum.DASHBOARD) {
            handleSelectResources([...selectedResources, resource]);
        }
    });

    useEffect(() => {
        if (defaultSelectedResourse.item.length && isDefaultSelected(resource)) {
            if (myRef && myRef.current)
                myRef.current.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                    inline: "nearest"
                });
        }
    }, [defaultSelectedResourse.item, filteredResources]);

    useEffect(() => {
        if (resource.linkUploadStatus && ![LinkUploadStatus.DONE, LinkUploadStatus.FAILED].includes(resource.linkUploadStatus)) {
            const IntervalId = setInterval(
                () => {
                    get(
                        (data, status) => {
                            if (advancedResponseValidator(data, status)) {
                                if (data.status === "Failed" || data.status === "Done") {
                                    syncFileManager(true);
                                }
                            }
                        },
                        API.storage.check("v2", resource.id)
                    );
                },
                Number(getWebEnvConfig("CHECK_LINK_UPLOAD_STATUS"))
            );
            setIntervalId([..._intervalId, IntervalId]);
            return () => {
                clearInterval(IntervalId);
            };
        }
    }, [resource.linkUploadStatus]);

    useEffect(() => {
        if (resource.malware_risk === null && !isFolder(resource)) {
            const IntervalId = setInterval(
                () => {
                    get((data, status) => {
                        if (responseValidator(status)) {
                            if (data.malware_risk !== null) {
                                clearInterval(IntervalId);
                            }
                            if (resource.malware_risk === null && data.malware_risk !== null) {
                                handleUpdateResources(data);
                            }
                        }
                    }, API.fileManager.getObject(resource.id));
                },
                Number(getWebEnvConfig("CHECK_LINK_UPLOAD_STATUS"))
            );
            return () => {
                clearInterval(IntervalId);
            };
        }
    }, []);

    useEffect(() => {
        _intervalId.map((id) => {
            clearInterval(id);
        });
    }, [resource.linkUploadStatus]);

    const isAccessCollabora = !activePurchases || !giftPurchase ? undefined : activePurchases.purchasesPlans.length + giftPurchase.length > 1;

    const isCollaboraFeature = getWebEnvConfig("COLLABORA") === "true";

    const handleOnClick = (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        handleClearDefaultSelectedItem();
        if (!(resource.linkUploadStatus && ![LinkUploadStatus.DONE].includes(resource.linkUploadStatus))) {
            if (device === DeviceEnum.desktop || selectedResources.length >= 1) {
                if (e.shiftKey) {
                    if (selectedResources.length > 0) {
                        const files = filteredResources.map((item) => item.id);
                        const visibleSelected = selectedResources.filter((item) => files.includes(item.id));
                        const firstSelectedResource = visibleSelected[0];
                        if (firstSelectedResource) {
                            const firstSelectedResourceIndex = filteredResources.findIndex(
                                (resource: ResourceType) => resource.id === firstSelectedResource.id
                            );
                            if (firstSelectedResourceIndex < index) {
                                handleSelectResources([
                                    ...selectedResources,
                                    firstSelectedResource,
                                    ...filteredResources.filter((_item: ResourceType, i: number) => i > firstSelectedResourceIndex && i <= index)
                                ]);
                            } else {
                                handleSelectResources([
                                    ...selectedResources,
                                    firstSelectedResource,
                                    ...filteredResources.filter((_item: ResourceType, i: number) => i < firstSelectedResourceIndex && i >= index)
                                ]);
                            }
                        }
                    }
                } else {
                    if (!isResourceSelected(resource)) {
                        if (mode === FileManagerModeEnum.DASHBOARD) {
                            handleSelectResources([resource]);
                        } else {
                            handleSelectResources([...selectedResources, resource]);
                        }
                    } else {
                        handleSelectResources(selectedResources.filter((res: any) => res.id !== resource.id));
                    }
                }
            } else {
                if (mode === FileManagerModeEnum.MAIN || mode === FileManagerModeEnum.FAVORITE || mode === FileManagerModeEnum.DASHBOARD) {
                    if (isFolder(resource)) navigate(`${PATH.files}?path=${resource.id}`);
                    else if (collaboraExtensionsChecker(resource)) {
                        if (!isCollaboraFeature) {
                            handleSelectResources([resource]);
                            handleSetDownloadConfirmationModalStatus(true);
                        } else if (isAccessCollabora === undefined) return;
                        else if (isAccessCollabora) handleOpenCollabora(resource);
                        else {
                            handleSelectResources([resource]);
                            handleSetCollaboraModalStatus(true);
                        }
                    } else if (!previewValidFormats.includes(getFileExtension(resource.name)!)) {
                        handleSetIsSingleSelect(true);
                        handleSelectResources([resource]);
                        handleSetDownloadConfirmationModalStatus(true);
                    } else {
                        handleSetIsSingleSelect(true);
                        handleSelectResources([...selectedResources, resource]);
                        if (collaboraOtherExtensionsChecker(resource)) {
                            if (!isCollaboraFeature) handleSetPreviewModalStatus(true);
                            else if (isAccessCollabora === undefined) return;
                            else if (isAccessCollabora) handleOpenCollabora(resource);
                            else handleSetPreviewModalStatus(true);
                        } else handleSetPreviewModalStatus(true);
                    }
                }
            }
        }
    };

    const retryHandler = (e: any) => {
        e.stopPropagation();
        e.preventDefault();
        return new Promise((resolve) => {
            post(
                (data, status) => {
                    if (advancedResponseValidator(data, status)) {
                        handleSetLinkUploadModalStatus(false);
                        toast({ title: toastMessages(80), type: "success" });
                        const resourcess = resources?.map((item) => {
                            if (item.id === resource.id) {
                                return {
                                    ...item,
                                    linkUploadStatus: LinkUploadStatus.NEW,
                                    last_modified: Math.floor(Date.now() / 1000),
                                    created_at: Math.floor(Date.now() / 1000)
                                };
                            } else {
                                return item;
                            }
                        });
                        handleSetResources(resourcess);
                        resolve(true);
                    }
                },
                API.storage.add(),
                {
                    url: resource.download_url,
                    name: resource.name,
                    parent: getFileManagerParent()
                }
            );
        });
    };

    const handleOnDrop = async (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        if (
            isFolder(resource)
            // todo: prevent upload condition
            // && fileManager.activePurchases && fileManager.activePurchases.userPlanStatus === UserPlanStatus.normal
        ) {
            if (e.dataTransfer.getData("id")) {
                if (selectedResources.length > 0) {
                    const draggedIds = selectedResources.map((resource) => resource.id);
                    if (!draggedIds.includes(resource.id)) {
                        cutResources(undefined, resource.id);
                    }
                    handleClearAllSelectedResources();
                } else {
                    if (Number(e.dataTransfer.getData("id")) !== resource.id) {
                        cutResources(Number(e.dataTransfer.getData("id")), resource.id);
                    }
                }
            } else {
                if (onDropFiles) {
                    setDragStatus(false);
                    const files = await getFilesFromDataTransferItems(e.dataTransfer.items);
                    onDropFiles(files, resource.id);
                }
            }
        } else {
            if (
                onDropFiles
                // todo: prevent upload condition
                // && fileManager.activePurchases && fileManager.activePurchases.userPlanStatus === UserPlanStatus.normal
            ) {
                setDragStatus(false);
                const files = await getFilesFromDataTransferItems(e.dataTransfer.items);
                onDropFiles(files, getFileManagerParent());
            }
        }
        setDragStatus(false);
    };

    const handleOnDragStart = (e: any) => {
        // todo: prevent upload condition
        // if (fileManager.activePurchases && fileManager.activePurchases.userPlanStatus === UserPlanStatus.normal)
        e.dataTransfer.setData("id", resource.id);
    };

    const handleRemoveFailedUploadLink = () => {
        del((data, status) => {
            if (advancedResponseValidator(data, status)) {
                const resourcess = resources?.filter((item) => item.id !== resource.id);
                handleSetResources(resourcess);
                toast({ title: toastMessages(79), type: "success" });
            }
        }, API.storage.deleteUploadLink(resource.id));
    };

    const handleOnDragOver = (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        if (
            onFileDragOver
            // todo: prevent upload condition
            // && fileManager.activePurchases && fileManager.activePurchases.userPlanStatus === UserPlanStatus.normal
        ) {
            if (isFolder(resource)) {
                setDragStatus(true);
            } else {
                if (e.dataTransfer.types[0] !== "id") {
                    onFileDragOver();
                }
            }
        }
    };

    const handleOnDragLeave = (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        if (onFileDragLeave) {
            if (isFolder(resource)) {
                setDragStatus(false);
            } else {
                onFileDragLeave();
            }
        }
    };

    const handleDoubleClick = (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        if (
            !isTouchScreen() &&
            (mode === FileManagerModeEnum.MAIN || mode === FileManagerModeEnum.FAVORITE || mode === FileManagerModeEnum.DASHBOARD) &&
            !(resource.linkUploadStatus && ![LinkUploadStatus.DONE].includes(resource.linkUploadStatus))
        ) {
            handleSelectResources([resource]);
            handleSetIsSingleSelect(true);
            if (device === DeviceEnum.desktop && selectedResources.length < 2) {
                if (isFolder(resource)) navigate(`${PATH.files}?path=${resource.id}`);
                else if (collaboraExtensionsChecker()) {
                    if (!isCollaboraFeature) {
                        handleSelectResources([resource]);
                        handleSetDownloadConfirmationModalStatus(true);
                    } else if (isAccessCollabora === undefined) return;
                    else if (isAccessCollabora) handleOpenCollabora(resource);
                    else {
                        handleSelectResources([resource]);
                        handleSetCollaboraModalStatus(true);
                    }
                } else if (!previewValidFormats.includes(getFileExtension(resource.name)!)) handleSetDownloadConfirmationModalStatus(true);
                else {
                    if (collaboraOtherExtensionsChecker(resource)) {
                        if (!isCollaboraFeature) handleSetPreviewModalStatus(true);
                        else if (isAccessCollabora === undefined) return;
                        else if (isAccessCollabora) handleOpenCollabora(resource);
                        else handleSetPreviewModalStatus(true);
                    } else handleSetPreviewModalStatus(true);
                }
            }
        }
    };

    const handleClickOptionsButton = (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        handleSetIsSingleSelect(true);
        handleSelectResources([resource]);
        const xPosition = e.pageX;
        const yPosition = e.pageY;
        if (mode === FileManagerModeEnum.MAIN) {
            if (isFolder(resource)) {
                setContextMenu(
                    true,
                    {
                        x: xPosition,
                        y: yPosition
                    },
                    resource.is_favorite ? contextMenuState.singleFolderSelectedWithFavorite : contextMenuState.singleFolderSelected
                );
            } else {
                setContextMenu(
                    true,
                    {
                        x: xPosition,
                        y: yPosition
                    },
                    resource.is_favorite ? contextMenuState.singleFileSelectedWithFavorite : contextMenuState.singleFileSelected
                );
            }
        } else if (mode === FileManagerModeEnum.DASHBOARD) {
            if (isFolder(resource)) {
                setContextMenu(
                    true,
                    {
                        x: xPosition,
                        y: yPosition
                    },
                    resource.is_favorite ? contextMenuState.dashboardSingleFolderSelectedWithFavorite : contextMenuState.dashboardSingleFolderSelected
                );
            } else {
                setContextMenu(
                    true,
                    {
                        x: xPosition,
                        y: yPosition
                    },
                    resource.is_favorite ? contextMenuState.dashboardSingleFileSelectedWithFavorite : contextMenuState.dashboardSingleFileSelected
                );
            }
        } else if (mode === FileManagerModeEnum.FAVORITE) {
            if (isFolder(resource)) {
                setContextMenu(true, { x: xPosition, y: yPosition }, contextMenuState.favoriteSingleFolderSelected);
            } else {
                setContextMenu(true, { x: xPosition, y: yPosition }, contextMenuState.favoriteSingleFileSelected);
            }
        } else if (mode === FileManagerModeEnum.TRASH) {
            setContextMenu(true, { x: xPosition, y: yPosition }, contextMenuState.trash);
        } else if (mode === FileManagerModeEnum.DUPLICATED_LIST) {
            setContextMenu(
                true,
                {
                    x: xPosition,
                    y: yPosition
                },
                resource.is_favorite ? contextMenuState.singleDuplicatedFileSelectedWithFavorite : contextMenuState.singleDuplicatedFileSelected
            );
        }
    };

    const handleSelect = () => {
        handleSetIsSingleSelect(true);
        handleSelectResources([resource]);
    };

    const handleRename = () => {
        handleSelect();
        handleSetRenameModalStatus(true);
    };

    const handleShare = () => {
        handleSelect();
        handleSetShareModalStatus(true);
    };

    const handleDownload = () => {
        handleSelect();
        if (localStorage.getItem("HAMRAHI_DOWNLOAD_ALERT")) {
            downloadResource();
        } else {
            handleSetDownloadModalStatus(true);
        }
    };

    const handleFavorite = () => {
        handleSelect();
        addToFavoriteResources(FileManagerModeEnum.MAIN);
    };

    const handleRemoveFavorite = () => {
        handleSelect();
        deleteFromFavoriteResources(FileManagerModeEnum.MAIN);
    };

    const handleNavigateToParent = () => {
        const resourceParent = resource.parent ? `${PATH.files}?path=${resource.parent.toString()}` : PATH.files;
        navigate(resourceParent);
    };

    const format = resource.name ? resource.name.match(allFormatRegex) : "";

    return (
        <>
            {/* <LockExcelDialog
                userName={user?.name}
                open={errorDialog}
                closeHandler={() => setErrorDialog(false)}
                version_group={resource.version_group!}
                navigatingToPath={() => navigate(PATH.excelEditor(resource.version_group, resource.parent))}
            /> */}
            {
                // Grid
                (view === FileManagerView.grid || location.pathname === PATH.dashboard) && (
                    <div
                        draggable={mode === FileManagerModeEnum.MAIN}
                        onDragStart={handleOnDragStart}
                        className={`resource-card flex flex-col border p-2 mb-4 relative overflow-hidden ${detail ? "h-[160px]" : "h-[140px]"} min-w-[120px] md:min-w-[200px] flex-1 rounded-[10px] cursor-pointer transition-all group drop-shadow-sm ${resource.linkUploadStatus && [LinkUploadStatus.FAILED].includes(resource.linkUploadStatus) ? "!border-red-300" : ""} ${isResourceSelected(resource) || isDefaultSelected(resource) ? "!bg-primary-100 border-primary-100" : "bg-white lg:bg-[#F6F8FF] hover:!bg-secondary-200 border-[#F6F8FF]"} ${dragStatus && "border-dashed !border-primary-600 !bg-primary-100"} ${parentDrag && "!bg-[#F7F7FC]"}`}
                        ref={myRef}
                    >
                        <div
                            className="absolute top-0 left-0 w-full h-full resource z-[1]"
                            data-resource-id={resource.id}
                            onClick={handleOnClick}
                            onDoubleClick={handleDoubleClick}
                            onDrop={handleOnDrop}
                            onDragOver={handleOnDragOver}
                            onDragLeave={handleOnDragLeave}
                            {...bindLongPress()}
                            title={resource.name}
                        />
                        {resource.from_link && resource.linkUploadStatus === LinkUploadStatus.FAILED && (
                            <div className="absolute top-0 left-0 w-full h-full bg-white bg-opacity-80 z-[2] flex items-center justify-center flex-col">
                                <img className="w-[50px] h-[50px] mx-auto object-contain" src={uploadLinkFailed} alt={resource.name} />
                                <div
                                    className={`absolute shrink-0 top-3 left-3 flex items-center justify-center w-[20px] h-[20px] rounded-[6px] transition-all`}
                                    onClick={() => setRemoveFailedUploadLink(true)}
                                >
                                    <img src={RedClose} alt="tick" className={`transition-all`} />
                                </div>
                                <div
                                    className={`${!(resource.from_link && resource.linkUploadStatus === LinkUploadStatus.FAILED) && "hidden"} mt-4 w-full text-[13px] justify-center font-[400] flex text-primary-600`}
                                    onClick={retryHandler}
                                >
                                    <span className="px-2">{"تلاش مجدد"}</span>
                                    <RetryUploadLink />
                                </div>
                            </div>
                        )}
                        {resource.linkUploadStatus &&
                            [LinkUploadStatus.QUEUED, LinkUploadStatus.NEW, LinkUploadStatus.CONSUMING].includes(resource.linkUploadStatus) && (
                                <div className="absolute top-0 left-0 w-full h-full bg-white bg-opacity-80 z-[2] flex items-center justify-center flex-col">
                                    <LinkUploadLoader className="spinner-border text-blue-300 animate-spin inline-block rounded-full" role="status" />
                                </div>
                            )}
                        <div className="flex items-center justify-between gap-2">
                            <div className="flex items-center gap-2 flex-1 overflow-hidden">
                                {!(resource.linkUploadStatus && ![LinkUploadStatus.DONE].includes(resource.linkUploadStatus)) && (
                                    <div
                                        className={`flex shrink-0 items-center justify-center border-[1.5px] border-secondary-500 w-[14px] h-[14px] aspect-square rounded-[4px] ${(selectedResources.length === 0 || isSingleSelect) && "hidden"} ${isResourceSelected(resource) && "bg-primary-600 !border-primary-600"} group-hover:flex transition-all`}
                                    >
                                        <img
                                            src={tick}
                                            alt="tick"
                                            className={`transition-all shrink-0  w-[8px] h-[8px] aspect-square ${isResourceSelected(resource) ? "opacity-100" : "opacity-0"}`}
                                        />
                                    </div>
                                )}
                                {(selectedResources.length === 0 ||
                                    isSingleSelect ||
                                    (resource.linkUploadStatus && ![LinkUploadStatus.DONE].includes(resource.linkUploadStatus))) && (
                                    <img
                                        className={`w-[14px] h-[14px] aspect-square drop-shadow-lg shrink-0 ${!(resource.linkUploadStatus && ![LinkUploadStatus.DONE].includes(resource.linkUploadStatus)) && "group-hover:hidden"}`}
                                        src={isFolder(resource) ? folderIcon : setResourceIcon(getFileNameWithoutFormat(resource).format)}
                                        alt={resource.name}
                                        loading="lazy"
                                    />
                                )}
                                <span className="text-[12px] truncate text-secondary-600 relative top-[1px] fix-text-alignment">
                                    <NameDisplay TextInput={resource.name} />
                                </span>
                                {resource.is_favorite && (
                                    <img src={star} alt="star" className="w-[14px] h-[14px] shrink-0 aspect-square relative bottom-[1px]" />
                                )}
                            </div>
                            {!(resource.linkUploadStatus && ![LinkUploadStatus.DONE].includes(resource.linkUploadStatus)) && (
                                <div className={`z-[2] shrink-0`} onClick={handleClickOptionsButton}>
                                    <img src={more} alt="more" className="w-[18px] h-[18px] aspect-square" />
                                </div>
                            )}
                        </div>
                        <div
                            className={`flex-1 relative flex items-center justify-center overflow-hidden rounded-[10px] ${resource.has_cover && "mt-2"}`}
                        >
                            <div className="absolute right-2 top-2 flex flex-col gap-1">
                                {resource.from_link && (
                                    <div
                                        className={`flex items-center justify-center w-[24px] h-[24px] p-1 ${resource.has_cover && "bg-secondary-600 rounded-[4px]"}`}
                                    >
                                        <LinkUploadSign className={`fill-secondary-500 ${resource.has_cover && "fill-white"}`} />
                                    </div>
                                )}
                                {(resource.is_shared || resource.has_link) && (
                                    <div
                                        className={`flex items-center justify-center w-[24px] h-[24px] p-1 ${resource.has_cover && "bg-secondary-600 rounded-[4px]"}`}
                                    >
                                        <SharedIcon className={`fill-secondary-500 ${resource.has_cover && "fill-white"}`} />
                                    </div>
                                )}
                                <AntivirusStatus resource={resource} view={view} />
                            </div>
                            {isFolder(resource) ? (
                                <img src={folderIcon} alt={resource.name} className="w-[70px] h-[70px]" />
                            ) : resource.has_cover ? (
                                <div className="flex-1 flex items-center justify-center w-full h-full">
                                    {getFileExtension(resource.name) !== "svg" ? (
                                        <img
                                            src={`${resource.download_url}?thumb=true`}
                                            alt={resource.name}
                                            className="object-cover w-full h-full aspect-video"
                                        />
                                    ) : (
                                        <img src={resource.download_url} alt={resource.name} className="w-[137px] h-[90px]" />
                                    )}
                                </div>
                            ) : (
                                <div>
                                    <div className="relative">
                                        {((resource.from_link && resource.linkUploadStatus !== LinkUploadStatus.FAILED) || !resource.from_link) && (
                                            <>
                                                <div
                                                    className={`text-white text-[12px] ${format && (format[0].slice(1).length === 6 || format[0].slice(1).length === 5) && "text-[7px]"} ${format && format[0].slice(1).length === 4 && "text-[10px]"} absolute top-2 right-[5px] rounded-sm w-full tracking-widest uppercase`}
                                                >
                                                    {format ? format[0].slice(1) : null}
                                                </div>
                                                <img
                                                    className="w-[60px] h-[60px]"
                                                    src={setResourceIcon(getFileNameWithoutFormat(resource).format)}
                                                    alt={resource.name}
                                                />
                                            </>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                        {detail && <p className="text-[12px] text-secondary-400 mt-2">{detail}</p>}
                    </div>
                )
            }
            {view === FileManagerView.list && location.pathname !== PATH.dashboard && (
                <div
                    ref={myRef}
                    draggable={mode === FileManagerModeEnum.MAIN}
                    onDragStart={handleOnDragStart}
                    className={`resource-card z-[0] overflow-hidden w-full border-[1px] border-transparent hover:border-secondary-400 cursor-pointer relative bg-[#F6F8FF] rounded-[8px] p-4 group mb-2 transition-all ${resource.linkUploadStatus && [LinkUploadStatus.FAILED].includes(resource.linkUploadStatus) ? "!border-red-300" : ""} ${isResourceSelected(resource) || isDefaultSelected(resource) ? "!bg-primary-100 border-primary-100" : "bg-white lg:bg-[#F6F8FF] hover:!bg-secondary-200 border-[#F6F8FF]"} ${dragStatus && "border-dashed !border-primary-600 !bg-primary-100"} ${parentDrag && "!bg-[#F7F7FC]"}`}
                >
                    <div
                        className="absolute top-0 left-0 w-full h-full resource z-[1]"
                        data-resource-id={resource.id}
                        onClick={handleOnClick}
                        onDoubleClick={handleDoubleClick}
                        onDrop={handleOnDrop}
                        onDragOver={handleOnDragOver}
                        onDragLeave={handleOnDragLeave}
                        {...bindLongPress()}
                        title={resource.name}
                    />
                    <div className="flex justify-between items-center lg:grid grid-cols-5 gap-4">
                        <div className={`flex items-center gap-2 overflow-auto col-span-2`}>
                            {!(resource.linkUploadStatus && ![LinkUploadStatus.DONE].includes(resource.linkUploadStatus)) && (
                                <div
                                    className={`flex shrink-0 items-center justify-center border-[1.5px] border-secondary-500 w-[22px] h-[22px] aspect-square rounded-[8px] ${(selectedResources.length === 0 || isSingleSelect) && "hidden"} ${isResourceSelected(resource) && "bg-primary-600 !border-primary-600"} lg:group-hover:flex transition-all`}
                                >
                                    <img
                                        src={tick}
                                        alt="tick"
                                        className={`transition-all w-[8px] h-[8px] aspect-square ${isResourceSelected(resource) ? "opacity-100" : "opacity-0"}`}
                                    />
                                </div>
                            )}
                            {(selectedResources.length === 0 ||
                                isSingleSelect ||
                                (resource.linkUploadStatus && ![LinkUploadStatus.DONE].includes(resource.linkUploadStatus))) && (
                                <div
                                    className={`${!(resource.linkUploadStatus && ![LinkUploadStatus.DONE].includes(resource.linkUploadStatus)) && "lg:group-hover:hidden"} shrink-0 w-[22px] h-[22px] aspect-square`}
                                >
                                    {isFolder(resource) ? (
                                        <img src={folderIcon} alt={resource.name} className="w-full aspect-square" />
                                    ) : resource.has_cover ? (
                                        <div className="flex shrink-0 items-center justify-center w-full">
                                            {getFileExtension(resource.name) !== "svg" ? (
                                                <img
                                                    src={`${resource.download_url}?thumb=true`}
                                                    alt={resource.name}
                                                    className="object-cover rounded-full aspect-square"
                                                />
                                            ) : (
                                                <img src={resource.download_url} alt={resource.name} className="w-auto h-full" />
                                            )}
                                        </div>
                                    ) : (
                                        <div>
                                            <div className="relative">
                                                <img
                                                    className="w-full shrink-0 aspect-square drop-shadow-md"
                                                    src={setResourceIcon(getFileNameWithoutFormat(resource).format)}
                                                    alt={resource.name}
                                                    loading="lazy"
                                                />
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}
                            <div className="flex flex-col overflow-auto overflow-y-hidden pb-[2px]">
                                <div className="flex items-center gap-2 w-auto">
                                    <p className="text-secondary-800 truncate text-[14px] fix-text-alignment relative top-[2px]">
                                        <NameDisplay TextInput={resource.name} />
                                    </p>
                                    <div className="flex items-center gap-2 shrink-0">
                                        {resource.is_favorite && (
                                            <img src={star} alt="star" className="w-[14px] lg:w-[20px] h-[14px] lg:h-[20px] shrink-0 aspect-square" />
                                        )}
                                        {resource.from_link && resource.linkUploadStatus !== LinkUploadStatus.FAILED && (
                                            <div
                                                className={`hidden lg:flex items-center justify-center w-[20px] h-[20px] rounded-[6px] shrink-0 bg-secondary-300`}
                                            >
                                                <LinkUploadSign className={`fill-secondary-600 scale-[0.8]`} />
                                            </div>
                                        )}
                                        {resource.from_link && resource.linkUploadStatus === LinkUploadStatus.FAILED && (
                                            <img className="w-[20px] h-[20px] mx-auto object-contain" src={uploadLinkFailed} alt={resource.name} />
                                        )}
                                        {resource.from_link && resource.linkUploadStatus === LinkUploadStatus.FAILED && (
                                            <div
                                                className={`${!(resource.from_link && resource.linkUploadStatus === LinkUploadStatus.FAILED) && "hidden"} relative top-[2px] w-full text-[13px] justify-center font-[400] flex text-primary-600 z-[2]`}
                                                onClick={retryHandler}
                                            >
                                                <span className="px-2">{"تلاش مجدد"}</span>
                                                <RetryUploadLink />
                                            </div>
                                        )}
                                        {(resource.is_shared || resource.has_link) && (
                                            <div
                                                className={`hidden lg:flex items-center justify-center w-[20px] h-[20px] rounded-[6px] shrink-0 bg-secondary-300`}
                                            >
                                                <SharedIcon className={`fill-secondary-600 scale-[0.8]`} />
                                            </div>
                                        )}
                                        {!isTouchScreen() && <AntivirusStatus resource={resource} view={view} />}
                                    </div>
                                </div>
                                {/* mobile */}
                                {resource.from_link &&
                                [LinkUploadStatus.NEW, LinkUploadStatus.QUEUED, LinkUploadStatus.FAILED, LinkUploadStatus.CONSUMING].includes(
                                    resource.linkUploadStatus!
                                ) ? null : (
                                    <div className="relative top-[2px] flex items-center gap-1 mt-1 lg:hidden">
                                        {resource.from_link && (
                                            <div
                                                className={`flex items-center justify-center w-[15px] h-[15px] rounded-[6px] shrink-0 bg-secondary-600 bg-opacity-80`}
                                            >
                                                <LinkUploadSign className={`fill-white scale-[0.6]`} />
                                            </div>
                                        )}
                                        {(resource.is_shared || resource.has_link) && (
                                            <div
                                                className={`flex items-center justify-center w-[15px] h-[15px] rounded-[6px] shrink-0 bg-secondary-600 bg-opacity-80`}
                                            >
                                                <SharedIcon className={`fill-white scale-[0.6]`} />
                                            </div>
                                        )}
                                        <AntivirusStatus resource={resource} view={view} />
                                        <p className="text-[12px] text-secondary-500">
                                            آخرین ویرایش{" "}
                                            {resource.last_modified
                                                ? moment.unix(resource.last_modified).fromNow()
                                                : moment.unix(resource.created_at).fromNow()}
                                        </p>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="text-[14px] text-secondary-600 hidden lg:block relative">
                            {resource.from_link
                                ? ![LinkUploadStatus.QUEUED, LinkUploadStatus.NEW, LinkUploadStatus.CONSUMING, LinkUploadStatus.FAILED].includes(
                                      resource.linkUploadStatus!
                                  )
                                    ? resource.last_modified
                                        ? moment.unix(resource.last_modified).fromNow()
                                        : moment.unix(resource.created_at).fromNow()
                                    : null
                                : resource.last_modified
                                  ? moment.unix(resource.last_modified).fromNow()
                                  : moment.unix(resource.created_at).fromNow()}
                        </div>
                        <div className="text-[14px] text-secondary-600 hidden lg:block relative">
                            {resource.from_link
                                ? ![LinkUploadStatus.QUEUED, LinkUploadStatus.NEW, LinkUploadStatus.CONSUMING, LinkUploadStatus.FAILED].includes(
                                      resource.linkUploadStatus!
                                  )
                                    ? resource.size
                                        ? `${Math.floor(UnitConvertStandard(resource.size).value)}${UnitConvertStandard(resource.size).unit}`
                                        : "-"
                                    : null
                                : resource.size
                                  ? `${Math.floor(UnitConvertStandard(resource.size).value)}${UnitConvertStandard(resource.size).unit}`
                                  : "-"}
                        </div>

                        <div className="col-span-1 flex justify-end items-center shrink-0">
                            {!(resource.linkUploadStatus && ![LinkUploadStatus.DONE].includes(resource.linkUploadStatus)) ? (
                                <div className="flex items-center gap-1">
                                    {selectedResources.length <= 1 && mode !== FileManagerModeEnum.TRASH && (
                                        <div className="hidden lg:group-hover:flex items-center gap-2 z-[2]">
                                            {mode === FileManagerModeEnum.DUPLICATED_LIST && (
                                                <Folder data-tip="رفتن به پوشه" className="fill-secondary-700" onClick={handleNavigateToParent} />
                                            )}

                                            <Share data-tip="اشتراک گذاری" className="fill-secondary-700" onClick={handleShare} />
                                            <Download data-tip="دانلود" className="fill-secondary-700" onClick={handleDownload} />
                                            <Rename data-tip="تغییر نام" className="fill-secondary-700" onClick={handleRename} />
                                            {resource.is_favorite ? (
                                                <StarSlash
                                                    data-tip="حذف از علاقه‌مندی‌ها"
                                                    className="fill-secondary-700"
                                                    onClick={handleRemoveFavorite}
                                                />
                                            ) : (
                                                <Star data-tip="افزودن به علاقه‌مندی‌ها" className="fill-secondary-700" onClick={handleFavorite} />
                                            )}
                                        </div>
                                    )}
                                    <div
                                        data-tip="موارد بیشتر "
                                        className={`shrink-0 w-fit flex items-center justify-center`}
                                        onClick={handleClickOptionsButton}
                                    >
                                        <img src={more} alt="more" className="w-[22px] h-[22px] aspect-square z-[2]" />
                                    </div>
                                </div>
                            ) : resource.linkUploadStatus &&
                              [LinkUploadStatus.QUEUED, LinkUploadStatus.NEW, LinkUploadStatus.CONSUMING].includes(resource.linkUploadStatus) ? (
                                <div className="absolute top-0 left-0 w-full h-full bg-white bg-opacity-80 z-[10] flex items-center justify-end">
                                    <div className="lds-ellipsis">
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                    </div>
                                </div>
                            ) : (
                                <div
                                    className={`flex shrink-0 items-center justify-center w-[20px] h-[20px] rounded-[6px] transition-all z-[2]`}
                                    onClick={() => setRemoveFailedUploadLink(true)}
                                >
                                    <img src={RedClose} alt="tick" className={`transition-all`} />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
            <ConfirmationModal
                modalType={"DELETE"}
                status={removeFailedUploadLink}
                onClose={() => {
                    setRemoveFailedUploadLink(false);
                }}
                onSubmit={handleRemoveFailedUploadLink}
                text="آیا از حذف لینک مطمئن هستید؟"
                cancelButtonText="خیر"
                submitButtonText="بله، حذف شود."
            />
        </>
    );
}
